<template>
	<el-dialog title="退款" width="550px" v-model="data.dialogTableVisible">
		<el-form label-width="90px">
			<el-form-item label="姓名">
				{{ currentData.userName }}
			</el-form-item>
			<el-form-item label="支持退款金额">
				{{ currentData.tkAmout }}
			</el-form-item>
			<el-form-item label="退款原因" required>
				<el-input
					type="textarea"
					:autosize="{ minRows: 2 }"
					placeholder="请输入退款原因"
					v-model="data.userTypeRefuseReason"
				>
				</el-input>
			</el-form-item>
		</el-form>
		<footer class="tac" style="margin-top: 50px">
			<el-button type="danger" @click="handleSave(2)">审核拒绝</el-button>
			<el-button type="primary" @click="handleSave(0)"
				>审核通过</el-button
			>
		</footer>
	</el-dialog>
</template>

<script>
import { defineComponent, inject, reactive } from "vue";
import { apiUserTypeAudit } from "@/api/requestApis.js";
import { ElMessage } from "element-plus";
export default defineComponent({
	props: {
		currentData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props) {
		const userTypeInfo = inject("userTypeInfo");
		const handleUpdateTable = inject("handleUpdateTable");
		const data = reactive({
			dialogTableVisible: false,
			userTypeRefuseReason: "",
		});

		const handleReset = () => {
			data.userTypeRefuseReason = "";
		};

		const handleToggle = (val) => {
			data.dialogTableVisible = val;
		};
		const handleSave = async (status) => {
			let params = {
				id: props.currentData.id,
				userTypeAuditStatus: status,
				updateUserType: props.currentData.updateUserType,
			};
			if (status === 2) {
				if (data.userTypeRefuseReason === "") {
					ElMessage.warning("请填写拒绝原因");
					return;
				}
				params.userTypeRefuseReason = data.userTypeRefuseReason;
			}

			await apiUserTypeAudit(params);
			handleToggle(false);
			handleReset();
			handleUpdateTable();
		};
		return {
			userTypeInfo,
			handleSave,
			handleToggle,
			data,
		};
	},
});
</script>

<style scoped>
.imgBox {
	width: 150px;
	height: 100px;
}
</style>
